// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".la-security-questions__field{padding-bottom:2rem;font-size:14px}.la-security-questions__field-question{padding-bottom:1.5rem;font-weight:600;font-size:16px}.la-security-questions__field-option{font-weight:400}.la-security-questions__field-option label{margin-left:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
